import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import { createNewMessage, createSentMessage } from "../helpers/utils";
import {
  addNewMessageSuccessInChatList,
  writeMessage,
} from "../redux/rootActions";

interface IProps {
  text: string;
  value: string;
}

const ChatItemButton: React.FC<IProps> = (props: IProps) => {
  const dispatch = useDispatch();
  const { text, value } = props;
  // Dohvati trenutno ulogovanog korisnika iz Redux-a
  const user = useSelector((state: any) => state.Auth.user);

  const submitButtonValue = (value: string) => {
    // 1. Prvo dodajemo kliknuto dugme kao korisničku poruku u chat
    const sentMsg = createSentMessage(text, user.email, "");
    dispatch(addNewMessageSuccessInChatList(sentMsg));
    const message = createNewMessage(value);
    dispatch(writeMessage(message));
  };
  return (
    <Button
      className="chat-item-btn ml-1 btn-sm"
      onClick={() => submitButtonValue(value)}
    >
      {text}
    </Button>
  );
};

export default ChatItemButton;
